module.exports = __webpack_public_path__ + "media/56.c04768ad.mp3";